import { render } from "./BaseResponsiveNav.vue?vue&type=template&id=e4e13b60&scoped=true"
import script from "./BaseResponsiveNav.vue?vue&type=script&lang=js"
export * from "./BaseResponsiveNav.vue?vue&type=script&lang=js"

import "./BaseResponsiveNav.vue?vue&type=style&index=0&id=e4e13b60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4e13b60"]])

export default __exports__